import React from "react"

import "./holiday_ad.scss"

export const HolidayAd = () => (
  <div className="holiday-ad">
    <a href="/lunch-with-santa" title="Lunch with santa">
      <img
        src="/lunch_with_santa.jpeg"
        alt="Lunch With Santa at Eric's Italian Bistro"
      />
    </a>
  </div>
)
